import React, { useState } from 'react';
import './App.css';
import { fetchWeather } from './api/fetchWeather';

function App() {
  const [query, setQuery] = useState('');
  const [weather, setWeather] = useState('');
  const search = async (e) => {
    if (e.key === "Enter") {
      const data = await fetchWeather(query);
      console.log(data);
      setWeather(data);
      setQuery('');
    }
  }
  return (
    <div className="main-container">
      <input type="text" placeholder="Enter city name..." value={query} className="search"
        onChange={(e) => setQuery(e.target.value)}
        onKeyPress={search}
      />
      {weather.main && (
        <div className="city">
          <div className="city-name">
            <span>{weather.name}</span>
            <sup>{weather.sys.country}</sup>
          </div>
          <div className="city-temp">
            <span>{Math.round(weather.main.temp)}</span>
            <sup>&deg;C</sup>
          </div>
          <div className="info">
            <img className="city-icon" src={`https://openweathermap.org/img/wn/${weather.weather[0].icon}@2x.png`} alt={weather.weather[0].description} />
            <p>{weather.weather[0].description}</p>
          </div>
        </div>
      )

      }
    </div>
  );
}

export default App;
